import { render, staticRenderFns } from "./generalPolicyTab.vue?vue&type=template&id=1028d6ac&"
import script from "./generalPolicyTab.vue?vue&type=script&lang=js&"
export * from "./generalPolicyTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports